import { component_tool, utils_tool } from '@/tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import { WizClassifySelect } from '../../common'
import React from 'react'
import { WizTableForm } from '../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 , organizationNodeCategory:["2"]} })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
import moment from "moment";
//配置项
let componentName = 'dealerNewPersonTrain'


const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "经销商名称",
    name: "name",
    tableItem: {
      width: 280
    },
    searchItem: {
    }
  },
  // {
  //   title: "经销商简称",
  //   name: "shortName",
  //   tableItem: {
  //     width: 100
  //   },
  // },
  {
    title: '销售代码',
    name: 'preSalesNumber',
    searchItem: {},
    tableItem: {width: 100}
  },
  {
    title: '售后代码',
    name: 'afterSalesNumber',
    searchItem: {},
    tableItem: {width: 100}
  },

  {
    title: '站点类型',
    name: 'dealerType',
    dict: [
      {code: 1, codeName: '经销商'},
      {code: 2, codeName: '服务商'},
      { code: 99, codeName: '暂定' },
      { code: 0, codeName: '无' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      width: 120
    }
  },
  {
    title: "开店状态",
    name: "status",
    dataIndex: "status",
    dict: [
      { code: 0, codeName: "已关店" },
      { code: 1, codeName: "已开店" },
      { code: 2, codeName: "建设中" },
    ],
    searchItem: {type: 'select'},
    tableItem: {
      width: 80
    }
  },
  {
    title: '开店时间',
    name: 'openTime',
    tableItem:{
      render: (text, record) => {
        return formatterDate(text)
      }
    }
  },
  {
    title: "新店/老店",
    name: "oldNewShop",
    dataIndex: "oldNewShop",
    dict: [
      { code: 0, codeName: "新店" },
      { code: 1, codeName: "老店" },
    ],
    searchItem: {type: 'select'},
    tableItem: {
      width: 80
    }
  },
  {
    title: "DP状态未确认",
    name: "dpStatus",
    dataIndex: "dpStatus",
    dict: [
      { code: 0, codeName: "无" },
      { code: 1, codeName: "有" },
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "DP状态未确认人数",
    name: "dpNum",
    dataIndex: "dpNum",
    tableItem: {},
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        collapse: false,
        buttonSort: ['export','exportTypeReport'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          },
          {
            key: 'exportTypeReport',
            custom: true,
            params: {icon: 'export', children: '新开业人员培训详情导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "exportTypeReport",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
       // selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      // showAuth: {
      //   title: '适用范围',
      //   dataIndex: 'authData'
      // },
      rowOperateSort: ['look'],
      rowOperateView: [
        {
          key: "look",
          custom: true,
          params: { children: "查看"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              //pathname: "/requirementPersonnel/requirementPersonnelList/requirementPersonnelDetailList"
              pathname: "/dealerNewPersonTrain/dealerNewPersonTrainList/dealerNewPersonTrainDetailList"
            }
          }
        },
        {
          key: "enable",
          custom: true,
          params: {children: "设为老店"},
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateState",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const info = <font color='red'>{record.name}</font>
              const content = <div>您正在将{info}的“新店/老店”标识由“新店”设置为“老店”，此操作不可逆，操作成功后该经销商新加入的学员将以老店新人的考核要求进行培训，是否确认？</div>
              WizModal.confirm({
                title: '信息确认',
                content: content,
                width:500,
                onOk: () => {
                  callback && callback({
                    id: record['id'],
                    oldNewShop:1
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          },
          recordChangeParams: ({ record, rows }) => {
            return { hidden: !(record.oldNewShop===0 && record.status==1)}
          }
        },
      ],
      commonOperate: {
        add: true,
        update: true
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  updateState: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
